// src/components/AccountCreation/Step2_UserDetails.js
import React, { useState } from 'react';
import { MOCK_CORRECT_OTP } from './constants';

const Step2_UserDetails = ({ data, setData, nextStep }) => {
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setData(prevData => ({ ...prevData, user: { ...prevData.user, [name]: value } }));
  };

  const handleSendOtp = (e) => { e.preventDefault(); if (data.user.email) setIsOtpSent(true); };
  const handleVerifyOtp = (e) => {
    e.preventDefault();
    setOtpError('');
    setIsVerifying(true);
    setTimeout(() => {
      if (otp === MOCK_CORRECT_OTP) setIsOtpVerified(true);
      else setOtpError('Invalid OTP. Please try again.');
      setIsVerifying(false);
    }, 1500);
  };

  return (
    <div>
      <h2 className="text-center fw-bold mb-4">Your Details</h2>
      {!isOtpVerified ? (
        <form>
          <div className="mb-3"><label className="form-label fw-semibold" htmlFor="email">Email Address</label><div className="input-group"><input type="email" id="email" name="email" value={data.user.email} onChange={handleUserChange} disabled={isOtpSent} className="form-control" placeholder="you@example.com" /><button onClick={handleSendOtp} disabled={isOtpSent || !data.user.email} className="btn btn-secondary">{isOtpSent ? 'Sent' : 'Send OTP'}</button></div></div>
          {isOtpSent && (<div className="mb-3"><label className="form-label fw-semibold" htmlFor="otp">Verification Code</label><p className="form-text">Enter the 6-digit code sent to your email.</p><input type="text" id="otp" value={otp} onChange={(e) => setOtp(e.target.value)} className={`form-control ${otpError ? 'is-invalid' : ''}`} placeholder="123456" />{otpError && <div className="invalid-feedback">{otpError}</div>}<div className="text-end mt-3"><button onClick={handleVerifyOtp} disabled={isVerifying} className="btn btn-primary">{isVerifying ? 'Verifying...' : 'Verify Email'}</button></div></div>)}
        </form>
      ) : (
        <form>
          <div className="alert alert-success">Email Verified! Please complete your profile.</div>
          <div className="row g-3">
            <div className="col-md-6"><label className="form-label fw-semibold" htmlFor="firstName">First Name</label><input type="text" id="firstName" name="firstName" value={data.user.firstName} onChange={handleUserChange} className="form-control" /></div>
            <div className="col-md-6"><label className="form-label fw-semibold" htmlFor="lastName">Last Name</label><input type="text" id="lastName" name="lastName" value={data.user.lastName} onChange={handleUserChange} className="form-control" /></div>
            <div className="col-md-6"><label className="form-label fw-semibold" htmlFor="dob">Date of Birth</label><input type="date" id="dob" name="dob" value={data.user.dob} onChange={handleUserChange} className="form-control" /></div>
            <div className="col-md-6"><label className="form-label fw-semibold" htmlFor="username">Username</label><input type="text" id="username" name="username" value={data.user.username} onChange={handleUserChange} className="form-control" /></div>
            <div className="col-12"><label className="form-label fw-semibold" htmlFor="address">Address</label><input type="text" id="address" name="address" value={data.user.address} onChange={handleUserChange} className="form-control" /></div>
            <div className="col-12"><label className="form-label fw-semibold" htmlFor="password">Password</label><input type="password" id="password" name="password" value={data.user.password} onChange={handleUserChange} className="form-control" /></div>
            <div className="col-12"><label className="form-label fw-semibold" htmlFor="password">Confirm Password</label><input type="password" id="confirmPassword" name="confirmPassword" value={data.user.confirmPassword} onChange={handleUserChange} className="form-control" /></div>
          </div>
        </form>
      )}
      {isOtpVerified && <div className="text-end mt-4"><button onClick={nextStep} className="btn btn-primary">Next: Payment</button></div>}
    </div>
  );
};

export default Step2_UserDetails;
